import moment from 'moment';

import { PPU_TERMS_OF_USE_EN, PPU_TERMS_OF_USE_FR } from './claimbot.constants';
import { GLOBAL_LANGUAGES } from '../../../i18n';

function formatDateSubmitClaim(date) {
  if (date) {
    return moment(date).format('YYYY-MM-DDT00:00:00-00:00');
  }

  return '';
}

function reminderFormatDate({ date, baseDateFormat, months }) {
  return baseDateFormat
    .replace('{month}', months[date.getMonth()])
    .replace('{day}', date.getDate())
    .replace('{year}', date.getFullYear());
}

const getDateOrToday = (date) => {
  const [today] = new Date().toISOString().split('T');
  if (date > today) {
    return today;
  }

  return date;
};

const getTotalAttachmentSize = (attachments) => {
  if (!attachments || !attachments.length) {
    return 0;
  }

  return attachments.reduce((total, attachment) => {
    if (attachment.size) {
      return total + attachment.size;
    }
    return total;
  }, 0);
};

const atLeastOneAttachmentIsValid = (attachments) => {
  if (!attachments || !attachments.length) {
    return false;
  }

  return attachments.some((attachment) => attachment.valid);
};

const allAttachmentsAreValid = (attachments) => {
  if (!attachments || !attachments.length) {
    return false;
  }

  return attachments.every((attachment) => attachment.valid);
};

const validateFileSize = (file, maxSize) => {
  let isValid = true;
  let errorEntry = '';
  const { size } = file;

  if (size === 0) {
    isValid = false;
    errorEntry = 'zeroSizeFileError';
  } else if (size > (maxSize * 1024 * 1024)) {
    isValid = false;
    errorEntry = 'largeFile';
  }

  return {
    errorEntry,
    isValid,
  };
};

const getTermsOfUseByLanguage = (language) => {
  let link = PPU_TERMS_OF_USE_EN;

  // french
  if (language === GLOBAL_LANGUAGES[2].key) {
    link = PPU_TERMS_OF_USE_FR;
  }

  return link;
};

export {
  allAttachmentsAreValid,
  atLeastOneAttachmentIsValid,
  formatDateSubmitClaim,
  getDateOrToday,
  getTermsOfUseByLanguage,
  getTotalAttachmentSize,
  reminderFormatDate,
  validateFileSize,
};
